import type { AdminQueryPort } from "../../contracts/admin-query-port";
import type {
  AdminConversationContentAccessRequest,
  AdminConversationPage,
  AdminConversationQuery,
  AdminConversationTranscript,
  AdminQueryEnvelope,
} from "../../contracts/admin-read-models";

function createUnavailableError(message: string): Error & { code: "ADMIN_QUERY_SOURCE_UNAVAILABLE" } {
  return Object.assign(new Error(message), {
    code: "ADMIN_QUERY_SOURCE_UNAVAILABLE" as const,
  });
}

export async function searchConversationHistory(
  port: AdminQueryPort,
  query: AdminConversationQuery,
): Promise<AdminQueryEnvelope<AdminConversationPage>> {
  if (!port.searchConversations) {
    throw createUnavailableError("Admin conversation metadata source is unavailable.");
  }

  return port.searchConversations(query);
}

export async function accessConversationContent(
  port: AdminQueryPort,
  input: AdminConversationContentAccessRequest,
): Promise<AdminQueryEnvelope<AdminConversationTranscript>> {
  if (!port.accessConversationContent) {
    throw createUnavailableError("Admin conversation content source is unavailable.");
  }

  return port.accessConversationContent(input);
}
